import {
  notificationReadResponseSchema,
  notificationsListResponseSchema,
  notificationsQuerySchema,
  notificationsReadAllResponseSchema,
  notificationPreferenceResponseSchema,
  updateNotificationPreferenceRequestSchema,
  type UpdateNotificationPreferenceRequest,
} from "@chotca/config";
import type { RequestContext } from "./http";
import { requestJson, requestJsonWithMeta } from "./http";

export function createNotificationsResource(ctx: RequestContext) {
  return {
    list(query: { cursor?: string; limit?: number } = {}) {
      const q = notificationsQuerySchema.parse(query);
      return requestJsonWithMeta(ctx, {
        method: "GET",
        path: "/me/notifications",
        query: q,
        dataSchema: notificationsListResponseSchema,
        auth: true,
      });
    },

    markRead(notificationId: string) {
      return requestJson(ctx, {
        method: "POST",
        path: `/me/notifications/${notificationId}/read`,
        dataSchema: notificationReadResponseSchema,
        auth: true,
      });
    },

    markAllRead() {
      return requestJson(ctx, {
        method: "POST",
        path: `/me/notifications/read-all`,
        dataSchema: notificationsReadAllResponseSchema,
        auth: true,
      });
    },

    getPreferences() {
      return requestJson(ctx, {
        method: "GET",
        path: "/me/notification-preferences",
        dataSchema: notificationPreferenceResponseSchema,
        auth: true,
      });
    },

    updatePreferences(input: UpdateNotificationPreferenceRequest) {
      const body = updateNotificationPreferenceRequestSchema.parse(input);
      return requestJson(ctx, {
        method: "PATCH",
        path: "/me/notification-preferences",
        body,
        dataSchema: notificationPreferenceResponseSchema,
        auth: true,
      });
    },

    // Build the SSE URL for the realtime stream. EventSource can't set the
    // Authorization header, so the access token is passed as a query param
    // (the API's JwtStrategy accepts `?access_token=`). Returns null when
    // there's no token (logged out) so callers can skip connecting.
    async streamUrl(): Promise<string | null> {
      const token = await ctx.getAccessToken();
      if (!token) return null;
      const u = new URL(`${ctx.baseUrl}/me/notifications/stream`);
      u.searchParams.set("access_token", token);
      return u.toString();
    },
  };
}
